import { Injectable } from '@angular/core';
import {
   MatSnackBar,
   MatSnackBarConfig,
   MatSnackBarHorizontalPosition,
   MatSnackBarVerticalPosition,
} from '@angular/material';

// Own feature
import { AppUserMessageComponent } from './app-user-message.component';
import { AppUserMessageTypes, LogToConsole } from './app-user-message.types';


@Injectable()
export class AppUserMessageService {

   constructor(
      public snackBar: MatSnackBar
   ) {
   }

   showMessage(
      message: string,
      module: string = 'Unknown',
      logToConsole: LogToConsole = 'LOG'
   ) {
      if (logToConsole === 'LOG') {
         console.log('[' + module + '] ' + message);
      }

      const config = new MatSnackBarConfig();
      config.verticalPosition =  'bottom';
      config.horizontalPosition = 'center';
      config.duration = 5000;
      config.panelClass = ['appUserMessage'];
      config.data = {message: message, type: 'INFO'};

      this.snackBar.openFromComponent(AppUserMessageComponent, config);
   }

   showWarningMessage(
      message: string,
      module: string = 'Unknown',
      logToConsole: LogToConsole = 'LOG'
   ) {
      if (logToConsole === 'LOG') {
         console.warn('[' + module + '] ' + message);
      }

      const config = new MatSnackBarConfig();
      config.verticalPosition =  'bottom';
      config.horizontalPosition = 'center';
      config.duration = 5000;
      config.panelClass = ['appUserMessage'];
      config.data = {message: message, type: 'WARNING'};

      this.snackBar.openFromComponent(AppUserMessageComponent, config);
   }

   showErrorMessage(
      message: string,
      module: string = 'Unknown',
      logToConsole: LogToConsole = 'LOG'
   ) {
      if (logToConsole === 'LOG') {
         console.error('[' + module + '] ' + message);
      }

      const config = new MatSnackBarConfig();
      config.verticalPosition =  'bottom';
      config.horizontalPosition = 'center';
      config.duration = 5000;
      config.panelClass = ['appUserMessage'];
      config.data = {message: message, type: 'ERROR'};

      this.snackBar.openFromComponent(AppUserMessageComponent, config);
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/library/app-user-message/app-user-message.service.ts